export enum FormFieldType {
  TextField,
  Checkbox,
  Combobox,
  DatePicker,
  TimePicker,
  TimePickerFull,
  TextArea,
  NumberForm,
  FileUpload,
  SectionLabel,
  SectionTitle,
  Divider,
  MultipleChoice,
  Slider,
  Select,
  Alert,
  Switch,
  Autocomplete,
}
